<script lang="ts">
  // Check if gtag is available
  const isGtagAvailable = () => typeof gtag !== "undefined";
  // Function to send performance data to Google Analytics
  const sendPerformanceDataToGA = () => {
    if (typeof gtag !== "undefined") {
      const performance = window.performance;
      if (performance) {
        const timing = performance.timing;
        const pageLoadTime = timing.loadEventStart - timing.navigationStart;

        gtag("event", "page_load_time", {
          event_category: "Performance",
          event_label: "Page Load Time",
          value: pageLoadTime,
        });
      }
    }
  };

  // Send performance data after window load event
  window.onload = () => {
    sendPerformanceDataToGA();
  };

  // Page views (is this working? Go to 404 and check...)
  $: {
    if (isGtagAvailable()) {
      gtag("config", "G-DNXLDY1ZQ7", {
        page_title: document.title,
        page_path: window.location.pathname,
      });
    }
  }
</script>

<svelte:head>
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-DNXLDY1ZQ7">
  </script>
  <script>
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", "G-DNXLDY1ZQ7");
    gtag('config', 'AW-11002359683');
  </script>
</svelte:head>
